import * as models from '@app/models/index';
import { connect } from 'react-redux';
import PurchasePostageComponent from './purchase-postage.component';

function mapStateToProps(state: models.IAccountPostageState): models.IAccountPostageState {
	return {
		...state,
	};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchasePostageComponent);



// WEBPACK FOOTER //
// ./src/components/account/purchase-postage/purchase-postage.ts